import './FloatingLoading.css';
import LoadingAnimation from '../../../LoadingAnimation/LoadingAnimation';
import { useHistory } from 'react-router-dom';

const FloatingLoading = () => {

  const history = useHistory()

  const chooseClass = () => {
        if (history.location.pathname.includes('userPanel') || history.location.pathname.includes('EdycjaOgloszenia') || history.location.pathname.includes('login')) {
          return 'FloatingLoadingMainContainer'
        } else return 'FloatingLoadingMainContainerWithOutOutline'
  };

  return (
    <div className={chooseClass()}>
      <LoadingAnimation/> 
    </div> 
  )
}

export default FloatingLoading;
